import { Drawer, Grid, Typography } from 'antd';
import { FiX } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchDraftRegulationById } from '../../Draft.services.tsx';

const { useBreakpoint } = Grid;

const { Title, Text } = Typography;

const MoreInfo = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const screens = useBreakpoint();
  const { t } = useTranslation();
  const { id } = useParams();

  const { data } = useQuery({
    queryKey: ['draftRegulation', id],
    queryFn: () => fetchDraftRegulationById(id),
    enabled: !!id,
    retry: false,
  });
  return (
    <>
      <Drawer
        title={t('common.more')}
        placement="left"
        closable={false}
        onClose={onClose}
        open={open}
        width={screens.xs ? '100%' : 365}
        extra={
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <FiX fontSize={24} onClick={onClose} />
          </div>
        }
      >
        <Title style={{ padding: 0, margin: 0 }} level={4}>
          {t('common.specification')}
        </Title>
        {data?.regulationNumber && <Text type="secondary">Number: {data?.regulationNumber}</Text>}
      </Drawer>
    </>
  );
};

export default MoreInfo;